import { Primitives } from './Primitives';
import { QuickLink, QuickLinkProps } from '../../QuickLink';
import { ReactNode } from 'react';
import { NodeRendererType } from '@graphcms/rich-text-react-renderer';

export const elements: NodeRendererType = {
  ...Primitives,

  ul: ({ children }: { children: ReactNode }) => <ul>{children}</ul>,
  ol: ({ children }: { children: ReactNode }) => <ol>{children}</ol>,
  li: ({ children }: { children: ReactNode }) => <li>{children}</li>,
  list_item_child: ({ children }: { children: ReactNode }) => <>{children}</>,
  embed: {
    QuickLink: (props: QuickLinkProps) => {
      return (
        <QuickLink
          embedded
          data={{ headline: props.headline, quickLinkItems: props.quickLinkItems }}
        />
      );
    },
  },
};
